<template>
  <div class="modal-overlay web-auth-modal" v-if="visible" @click.self="close">
    <div class="modal-box">
      <div class="auth-box">
        <div class="logo"><div class="logo-icon"><img :src="logoImg" alt="logo" class="logo-icon-img" /></div><h1>修改登录密码</h1><p class="sub">验证码将发送至您的注册邮箱</p></div>
        <div class="form-group"><label>验证邮箱</label><div class="input-wrap"><input type="email" :value="email" readonly></div></div>
        <div class="form-group"><label>邮箱验证码</label><div class="input-wrap"><input type="text" v-model="form.code" placeholder="请输入验证码" maxlength="6"><button type="button" class="btn-code" @click="sendCode" :disabled="codeCooldown > 0">{{ codeCooldown > 0 ? codeCooldown + 's' : '获取验证码' }}</button></div></div>
        <div class="form-group"><label>新登录密码</label><div class="input-wrap"><input type="password" v-model="form.newPwd" placeholder="6-20 位" maxlength="20"></div></div>
        <div class="form-group"><label>确认新密码</label><div class="input-wrap"><input type="password" v-model="form.confirmPwd" placeholder="再次输入"></div></div>
        <button class="btn-primary" @click="doChange">确认修改</button>
      </div>
      <div style="text-align:center;margin-top:12px"><a href="javascript:void(0)" @click="close" style="color:#999;font-size:13px;text-decoration:none">关闭</a></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { showToast } from '@/utils/common'
import { changeLoginPwd } from '@/api/user'

export default {
  name: 'ChangeLoginPwdModal',
  props: { visible: Boolean },
  data() { return { logoImg: require('@/assets/logo/logo-icon.png'), form: { code: '', newPwd: '', confirmPwd: '' }, codeCooldown: 0, submitting: false } },
  computed: { ...mapState('user', ['email']) },
  methods: {
    close() { this.$emit('close') },
    async sendCode() {
      if (!this.email) return showToast('未获取到邮箱信息，请重新登录')
      this.codeCooldown = 60
      const timer = setInterval(() => { this.codeCooldown--; if (this.codeCooldown <= 0) clearInterval(timer) }, 1000)
      try {
        await this.$store.dispatch('user/sendCode', { email: this.email, scene: 'change_login_password' })
        showToast('验证码已发送，请查收邮箱')
      } catch (e) {
        clearInterval(timer)
        this.codeCooldown = 0
        showToast(e.message || '发送验证码失败')
      }
    },
    async doChange() {
      if (this.submitting) return
      if (!this.form.code || this.form.code.length !== 6) return showToast('请输入6位验证码')
      if (!this.form.newPwd || this.form.newPwd.length < 6 || this.form.newPwd.length > 20) return showToast('密码需6-20位')
      if (this.form.newPwd !== this.form.confirmPwd) return showToast('两次密码不一致')
      this.submitting = true
      try {
        const res = await changeLoginPwd({
          code: this.form.code,
          newPassword: this.form.newPwd,
          confirmPassword: this.form.confirmPwd
        })
        if (res.code === 200) {
          showToast(res.msg || '密码修改成功')
          this.close()
        } else {
          showToast(res.msg || '密码修改失败')
        }
      } catch (e) {
        showToast(e.message || '密码修改失败')
      } finally {
        this.submitting = false
      }
    }
  },
  watch: { visible(v) { if (v) this.form = { code: '', newPwd: '', confirmPwd: '' } } }
}
</script>

<style lang="scss" scoped>
.web-auth-modal .modal-box { width: 420px; padding: 32px 40px; }
.auth-box { width: 100%; }
.auth-box .logo { text-align: center; margin-bottom: 32px; }
.auth-box .logo-icon { width: 56px; height: 56px; background: transparent; border-radius: 14px; margin: 0 auto 12px; display: flex; align-items: center; justify-content: center; }
.auth-box .logo-icon-img { width: 56px; height: 56px; }
.auth-box h1 { font-size: 22px; text-align: center; }
.auth-box .sub { text-align: center; color: var(--text-secondary); font-size: 13px; margin-top: 4px; }
.btn-primary { width: 100%; padding: 12px; background: var(--red); color: #fff; border: none; border-radius: 6px; font-size: 15px; font-weight: 600; cursor: pointer; font-family: inherit; &:hover { opacity: .92; } }
.btn-code { flex-shrink: 0; padding: 0 14px; height: 42px; border: none; background: var(--red-soft); color: var(--red); font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; &:disabled { color: var(--text-muted); cursor: not-allowed; } }
</style>
